import { useState } from "react";
import { toast } from "sonner";
import { Download, FileText, Loader2 } from "lucide-react";
import { OrbitAI } from "@/components/OrbitAI";
import { exportPagePdf } from "@/lib/exportPdf";

const base = "inline-flex items-center gap-1.5 text-[11px] font-semibold px-3 py-1.5 rounded-lg border transition-colors whitespace-nowrap disabled:opacity-60";
export const ACTION_BTN = {
  ai: `${base} border-purple-200 bg-purple-50 hover:bg-purple-100 text-purple-800`,
  neutral: `${base} border-slate-200 bg-white hover:bg-slate-50 text-slate-700`,
};

/* Fait défiler jusqu'au premier bloc « Analyse IA » de la page (pages où l'analyse est intégrée au contenu). */
export function scrollToAiBlock() {
  const el = [...document.querySelectorAll("h3, h2, [data-testid*='ai-']")].find(e => /analyse ia|orbit ia|\bIA\b/i.test(e.textContent || "")) || document.querySelector("[data-testid*='ai']");
  if (el) { el.scrollIntoView({ behavior: "smooth", block: "start" }); el.classList.add("ring-2", "ring-purple-300"); setTimeout(() => el.classList.remove("ring-2", "ring-purple-300"), 1600); }
  else toast.info("Aucun bloc d'analyse IA sur cet onglet");
}

/* Barre d'actions harmonisée : Analyse IA · Export Excel · Export PDF. À placer à droite de la barre de sous-onglets. */
export function PageActions({ title, filters, onAi, aiLabel = "Analyse IA", aiLoading = false, onExcel, excelLabel = "Export Excel", pdf = true, captureSelector, children, testid = "page-actions" }) {
  const [pdfBusy, setPdfBusy] = useState(false);
  const doPdf = async () => {
    setPdfBusy(true);
    try { await exportPagePdf({ title, filters: typeof filters === "function" ? filters() : filters, element: captureSelector ? document.querySelector(captureSelector) : undefined }); toast.success("PDF généré"); }
    catch (e) { toast.error("Export PDF impossible : " + (e?.message || e)); }
    finally { setPdfBusy(false); }
  };
  return <div className="flex items-center gap-2 flex-wrap ml-auto" data-testid={testid}>
    {children}
    {onAi && <button onClick={onAi} disabled={aiLoading} className={ACTION_BTN.ai} data-testid={`${testid}-ai`}>{aiLoading ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <OrbitAI className="w-3.5 h-3.5" />} {aiLabel}</button>}
    {onExcel && <button onClick={onExcel} className={ACTION_BTN.neutral} data-testid={`${testid}-excel`}><Download className="w-3.5 h-3.5" /> {excelLabel}</button>}
    {pdf && <button onClick={doPdf} disabled={pdfBusy} className={ACTION_BTN.neutral} data-testid={`${testid}-pdf`}>{pdfBusy ? <Loader2 className="w-3.5 h-3.5 animate-spin" /> : <FileText className="w-3.5 h-3.5" />} Export PDF</button>}
  </div>;
}

/* Barre de sous-onglets + actions à droite (même ligne). */
export function TabBar({ children, actions, className = "", testid }) {
  return <div className={`flex items-center gap-1 border-b border-slate-200 flex-wrap ${className}`} data-testid={testid}>
    {children}
    {actions && <div className="ml-auto pb-1.5 pl-2">{actions}</div>}
  </div>;
}
